import { z } from 'zod/v3'
import { paginationSearchSchema } from '@/lib/pagination'

// Kept on the detail URL so returning to People restores the same population.
export const auditorPeopleSearchSchema = paginationSearchSchema.extend({
  search: z.string().catch(''),
  status: z
    .enum(['all', 'ACTIVE', 'ON_LEAVE', 'TERMINATED', 'CONTRACTOR'])
    .catch('all'),
  population: z.enum(['all', 'period', 'hires', 'departures']).catch('all'),
  view: z.enum(['employees', 'excluded']).catch('employees'),
})
